import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { ActionService } from '../../services';
import { types as actions, editedActionAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_ACTION),
    switchMap(action =>
      ActionService.edit(action.action, store).pipe(
        map(data => editedActionAction(data)),
        catchError(retryAuthentication(action$, 'epics/actions/editAction'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/actions/editAction.js